import Grid from "@mui/material/Grid";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import {makeStyles} from "@mui/styles";
import styles from '../../../../assets/jss/LogBook/gridTableStyle';

const useStyles = makeStyles(styles);

export default function LogBookPagination(props) {
    const {nextWeek, lastWeek, page, dateFrom, dateTo,isLoading} = props
    const classes = useStyles();

    return (
        <Grid container
              pb={3}
              pl='6px'
              pr='6px'
              alignItems='center'
              justifyContent='space-between'
        >
            <Grid item className={classes.prev_next_week}>
                <KeyboardArrowRightIcon onClick={lastWeek} className={classes.arrowIcons}/>
                <span className={classes.prev_next_Text} style={{marginRight: '10px'}}>هفته قبل</span>
            </Grid>
            <Grid item className={classes.activeWeekText}>
                {isLoading ?
                    '' :
                    `از ${dateFrom} تا ${dateTo}`
                }
            </Grid>
            <Grid item className={classes.prev_next_week}>
                    <span className={`${classes.prev_next_Text} ${page === 0 && classes.disableIcon} `}
                          style={{marginLeft: '10px'}}>هفته بعد</span>
                <KeyboardArrowLeftIcon onClick={page !== 0 ? nextWeek : undefined}
                                       className={`${classes.arrowIcons} ${page === 0 && classes.disableIcon}`}/>
            </Grid>
        </Grid>
    )
}